module.exports = __webpack_public_path__ + "static/media/advice-brown.f828a6c7.svg";